import Dashboard from "./dashboard";
import Permission from "./permission";
const api = {
    dashboard: new Dashboard(),
    permission: new Permission()
};
export default api
